interface JsonResultProps {
  data: unknown;
}

export function JsonResult({ data }: JsonResultProps) {
  return (
    <div className="result">
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
